window.initPlugins = function(elem) {

    elem.find('.hamburger').hamburgerMenu();
    elem.find('.open-overlay').openOverlay();
    elem.find('.number-input').numberInput();
    elem.find('.product-chooser').productChooser();
    elem.find('.confirm').confirm();
    elem.find('.alert').alertbox();

	elem.find('.image-gallery').each(function () {

		var $imageSlider = $(this);

		$imageSlider.slick({
			dots: true,
			prevArrow: null,
			nextArrow: null
		});

		setTimeout(function () {
			$imageSlider.slick('slickGoTo', 0);
		}, 1);

	});

    elem.find('.ticketlist ul').each(function() {

    	var $slider = $(this),
			$nextTicketLink = $('.next-ticket-link'),
			$prevTicketLink = $('.prev-ticket-link');

		$slider.slick({
			centerMode: true,
			centerPadding: '320px',
			variableWidth: true,
			slidesToShow: 1,
			infinite: false,
			focusOnSelect: true,
			prevArrow: '.prev-ticket-link',
            nextArrow: '.next-ticket-link',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						centerPadding: '0'
					}
				}
            ]
		});

		$prevTicketLink.hide();

		$('.button-next-slide').on('click', function () {
			$slider.slick('slickNext');
		});

		$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {

			var $leavingSlide = $('li[data-slick-index='+ currentSlide +']'),
				$nextActiveSlide = $('li[data-slick-index='+ nextSlide +']');

			if (!$leavingSlide.hasClass('ticket-completed') && currentSlide < nextSlide) {
				event.preventDefault();
			}

			if (currentSlide > nextSlide) {
				$nextActiveSlide.addClass('ticket-completed-and-visited');
			}

		});

		$slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
			var $currentSlide = $('li[data-slick-index='+ currentSlide +']');

			if ($currentSlide.hasClass('ticket-completed')) {
				$nextTicketLink.fadeIn();
				$prevTicketLink.fadeIn();

				// If Back to slide 1, hide prev:
				if (currentSlide === 0) {
					$prevTicketLink.fadeOut();
				}

				// If on last slide
				if (currentSlide === $('.ticket-completed').length - 1) {
					checkNextTicketLinkVisibility($nextTicketLink);
				}

			} else {
				$nextTicketLink.fadeOut();
				$prevTicketLink.fadeIn();
			}
		});


		$(document).on('ticket-was-completed', function () {
			checkNextTicketLinkVisibility($nextTicketLink);
		});
    });

    function checkNextTicketLinkVisibility($nextTicketLink) {
		if ($('.button-next-step').is(':visible') ) {
			$nextTicketLink.fadeOut();
		} else {
			$nextTicketLink.fadeIn();
		}
	}

	elem.find('form.single-steps').formSingleSteps({
		scrollEasing: 'easeInOutQuad',
		scrollDuration: 300
	});


    elem.find('form.validate').formValidate();
    elem.find('.required, .validate').validate();

	elem.find('form.single-steps').formSingleSteps({
		scrollEasing: 'easeInOutQuad',
		scrollDuration: 300
	});

	elem.find('.button_inherit_data').on('click', function () {
		elem.find('.single-steps').getInheritedData();

		// Implicitly save, but with a small delay:
		setTimeout(function () {
			elem.find('button.show-ticket-preview').trigger('click');
		}, 500);
	});

    elem.find('.ticket-data').ticketData();

    elem.find('.equal-height').equalHeight();
    elem.find('.expandable').expandable();


    if ($('html').hasClass('no-touch')) { // use standard select for touch devices
        elem.find('.select2.basic-select').each(function() {
            var parent = $(this).parent();
            if ($(this).parents('.overlay').length) {
                parent = elem;
            }
            $(this).select2({
                minimumResultsForSearch: Infinity,
                placeholder: $(this).attr('placeholder'),
                dropdownParent: parent
            });
        });
        elem.find('.select2.select-searchable').each(function() {
            var parent = $(this).parent();
            if ($(this).parents('.overlay').length) {
                parent = elem;
            }
            $(this).select2({
                placeholder: $(this).attr('placeholder'),
                dropdownParent: parent
            });
        });
    } else {
        elem.find('.select2.no-touch').each(function() {
            var parent = $(this).parent();
            if ($(this).parents('.overlay').length) {
                parent = elem;
            }
            $(this).select2({
                placeholder: $(this).attr('placeholder'),
                dropdownParent: parent
            });
        });
        // add placeholder to select
        elem.find('.select2').each(function() {
            if ($(this).attr('placeholder') && !$(this).find('option').first().text().trim()) {
                $(this).find('option').first().text($(this).attr('placeholder'));
            }
        });
    }
};
window.reInitSelect = function () {
    if ($('html').hasClass('no-touch')) { // use standard select for touch devices
        $('body').find('.select2.basic-select').each(function() {
            var parent = $(this).parent();
            if ($(this).parents('.overlay').length) {
                parent = $('body');
            }
            
            $(this).select2('destroy').select2({
                minimumResultsForSearch: Infinity,
                placeholder: $(this).attr('placeholder'),
                dropdownParent: parent
            });
        });
        $('body').find('.select2.select-clearable').each(function() {
            var parent = $(this).parent();
            if ($(this).parents('.overlay').length) {
                parent = $('body');
            }
            
            $(this).select2('destroy').select2({
                minimumResultsForSearch: Infinity,
                allowClear: true,
                placeholder: $(this).attr('placeholder'),
                dropdownParent: parent
            });
        });
        $('body').find('.select2.select-searchable').each(function() {
            var parent = $(this).parent();
            if ($(this).parents('.overlay').length) {
                parent = $('body');
            }

            $(this).select2('destroy').select2({
                placeholder: $(this).attr('placeholder'),
                dropdownParent: parent
            });
        });
    } else {
        // add placeholder to select
        $('body').find('.select2.select-searchable.no-touch').each(function() {
            var parent = $(this).parent();
            if ($(this).parents('.overlay').length) {
                parent = $('body');
            }

            $(this).select2('destroy').select2({
                placeholder: $(this).attr('placeholder'),
                dropdownParent: parent
            });
        });
        $('body').find('.select2').each(function() {
            if ($(this).attr('placeholder') && !$(this).find('option').first().text().trim()) {
                $(this).find('option').first().text($(this).attr('placeholder'));
            }
        });
    }
};
jQuery(document).ready(function() {
    initPlugins($('body'));
    $('body').overlay();
    $('body').stickyFooter();
    $(window).on('resize', reInitSelect);
});

